import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { ReassignLicenseRequest } from '../../models/ss-api/requests/reassign.license.request';
import { Router } from '@angular/router';

export interface IKeyReassignDialogModel {
    LicenseID: number;
    CDKey: string;
}

@Component({
    selector: 'key-reassign-dialog',
    styleUrls: ['./key.reassign.dialog.css'],
    templateUrl: './key.reassign.dialog.html'
})
export class KeyReassignDialog extends DialogComponent<IKeyReassignDialogModel, boolean> implements IKeyReassignDialogModel {

    IsBusy: boolean = false;

    LicenseID: number;
    CDKey: string;

    NewMemberName: string;
    NewMemberEmail: string;
    NotifyOwner: boolean = true;
    NotifyDesigner: boolean = true;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    async confirm() {

        this.IsBusy = true;

        if (this.NewMemberEmail == undefined || this.NewMemberEmail == '') {
            await this.sweetAlertService.swal(
                {
                    title: 'Error',
                    text: 'No Email Address was provided!',
                    type: 'error',
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    allowOutsideClick: false,
                })
                .then(response => {
                    this.IsBusy = false;
                    return;
                }, dismiss => {
                    this.IsBusy = false;
                    return;
                });
            return;
        }

        let request = new ReassignLicenseRequest;
        request.LicenseID = this.LicenseID;
        request.NotifyEmail = this.NewMemberEmail;
        request.Name = this.NewMemberName;
        request.NotifyOwner = this.NotifyOwner;
        request.NotifyDesigner = this.NotifyDesigner;

        await this.sweetAlertService.swal(
            {
                title: 'Reassign Key?',
                text: 'Are you sure you want to reassign this License Key to ' + this.NewMemberEmail + '?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,

                preConfirm: () => {
                    return this.api.ReassignAndNotify(request).toPromise();
                }
            })
            .then(response => {
                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }
                // ok

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'License Key Reassigned',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });

                this.IsBusy = false;
                this.close();

            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;



    }

    Clear() {
        let request = new ReassignLicenseRequest;
        request.LicenseID = this.LicenseID;
        request.ClearKey = true;

        this.sweetAlertService.swal(
            {
                title: 'Clear Key?',
                text: 'Are you sure you want to clear this License Key?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,

                preConfirm: () => {
                    return this.api.ReassignAndNotify(request).toPromise();
                }
            })
            .then(response => {
                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }
                // ok

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'License Key Reassigned',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });

                this.IsBusy = false;
                this.close();

            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;
    }

    toggleNotifyOwner() {
        this.NotifyOwner = !this.NotifyOwner;
    }

    toggleNotifyDesigner() {
        this.NotifyDesigner = !this.NotifyDesigner;
    }

}
